import { useState, useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

import {
  firestoreDatabase,
  signInUserAnonymously,
} from "../../utils/firebase-utils";
import { collection, query, where, getDocs } from "firebase/firestore";

import "./sunday-prayers.styles.css";

import { UserContext } from "../../contexts/user-context";
import PrayNowBanner from "./pray-now-banner";
import SundayPrayer from "./sunday-prayer.js.js";
import ProgressBar from "./progress-bar";
import { ProgressBarContext } from "../../contexts/progress-bar-context";
import { HidePrayersContext } from "../../contexts/hide-prayers-context";
import { isUserDeleted } from "../../utils/is-user-deleted.js";

// just under one week to clear prayers before start of Sunday a.m. service
const ONE_WEEK = 1000 * 60 * 60 * 24 * 6.9;
const NOW = new Date().getTime();
const ONE_WEEK_AGO = NOW - ONE_WEEK;

const SundayPrayers = () => {
  const [prayers, setPrayers] = useState([]);
  const { hidePrayers, setHidePrayers } = useContext(HidePrayersContext);

  const { setCurrentUser } = useContext(UserContext);
  const navigate = useNavigate();

  const { setProgressBarValue } = useContext(ProgressBarContext);

  const signInAnonymously = async () => {
    try {
      const { user } = await signInUserAnonymously();
      await setUser(user);
      navigate("/");
    } catch (error) {
      alert("error");
    }
  };

  const setUser = (data) => {
    localStorage.setItem("user", JSON.stringify(data));
    setCurrentUser(data);
  };

  useEffect(() => {
    fetchPrayersFromFirestoreDb();

    let interval;
    let counter = 0;
    interval = setInterval(() => {
      if (counter <= 10) {
        counter++;
        fetchPrayersFromFirestoreDb();
      } else {
        clearInterval(interval);
        fetchPrayersWithoutIncrementingProgress();
      }
    }, 20000);
  }, []);

  const getUser = async () => {
    const storageUser = localStorage.getItem("user");
    const parsedStorageUser = JSON.parse(storageUser);

    const userCreatedMoreThanThirtyDaysAgo = isUserDeleted(
      parsedStorageUser.createdAt
    );

    if (!storageUser | userCreatedMoreThanThirtyDaysAgo) {
      localStorage.clear();
      await signInAnonymously();
    }
  };

  const fetchPrayersFromFirestoreDb = async () => {
    await getUser();

    const allPrayersQuery = await query(
      collection(firestoreDatabase, "prayers"),
      where("createdAtTimestamp", ">", ONE_WEEK_AGO)
    );
    const querySnapshot = await getDocs(allPrayersQuery);
    const allPrayers = [];
    querySnapshot.forEach((doc) => {
      allPrayers.push(doc.data());
    });

    if (allPrayers.length > 8) {
      const random = allPrayers.sort(() => 0.5 - Math.random()).slice(0, 8);
      setPrayers(random);
    } else {
      setPrayers(allPrayers);
    }

    let width = 0;
    setProgressBarValue(width);
    const incrementProgress = setInterval(function () {
      setHidePrayers(false);
      width += 0.53;
      if (width >= 100) {
        setHidePrayers(true);
        clearInterval(incrementProgress);
      }
      setProgressBarValue(width);
    }, 100);
  };

  const fetchPrayersWithoutIncrementingProgress = async () => {
    const allPrayersQuery = await query(
      collection(firestoreDatabase, "prayers"),
      where("createdAtTimestamp", ">", ONE_WEEK_AGO)
    );
    const querySnapshot = await getDocs(allPrayersQuery);
    const allPrayers = [];
    querySnapshot.forEach((doc) => {
      allPrayers.push(doc.data());
    });
    setProgressBarValue(100);
    setPrayers(allPrayers);
    setHidePrayers(false);
  };

  // TODO create empty state component
  if (prayers === null)
    return (
      <section className="prayers-container">
        <div>
          <p>No recent prayer requests. Submit one now!</p>
        </div>
      </section>
    );

  return (
    <>
      <PrayNowBanner />
      <ProgressBar hidden={hidePrayers} />
      <section className="sunday-prayers-container">
        {prayers.map((prayer) => (
          <SundayPrayer key={prayer.prayerId} prayer={prayer} />
        ))}
      </section>
    </>
  );
};

export default SundayPrayers;
